import { render, staticRenderFns } from "./demo-alcohol-promo-flow.vue?vue&type=template&id=3d2de5c4&scoped=true&"
import script from "./demo-alcohol-promo-flow.vue?vue&type=script&lang=js&"
export * from "./demo-alcohol-promo-flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2de5c4",
  null
  
)

export default component.exports